import { css } from "@emotion/react";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";
import { useRouter } from "next/router";
import { CompanyQuery, CompanyStatus } from "@/generated/graphql_billing";
import { isForcedCancellation } from "@/libs/billing/company";

type Props = {
  company: CompanyQuery["company"];
};

export const NoContract = (props: Props) => {
  const router = useRouter();
  return (
    <div css={container}>
      <Font>
        契約中のプランがありません。
        <br />
        下記より、ご希望のプランを選択してください。
      </Font>
      <div css={buttonContainer}>
        <Button
          onClick={() => router.push("/plan/select-plan")}
          disabled={isForcedCancellation(props.company)}
        >
          プラン選択
        </Button>
      </div>
    </div>
  );
};

const container = css({
  textAlign: "center",
  marginTop: "32px",
});

const buttonContainer = css({
  marginTop: "30px",
});
